import React from 'react'
import { connect } from 'react-redux'
import { pick } from 'lodash'
import { Link,  browserHistory } from 'react-router'
import { Row, Col, Panel, ButtonGroup, Glyphicon, Nav, NavItem } from 'react-bootstrap'
import DocumentTitle from "react-document-title"

import { isMobile, replaceQuery } from '../lib/AppTools'
import { l } from '../../lib/Tools'
import * as Actions from '../ducks/trips'
import { createBlock } from '../ducks/blocks'
import * as RouteActions from '../ducks/routes'
import Button from '../components/Button'

import PdfSettingsModal from './PdfSettingsModal'
import PriceSettingsModal from './PriceSettingsModals'
import TripNotesEditor from './TripNotesEditor'
import RouteTabber from './RouteTabber'
import PriceTag from './TripPriceTag'
import TripForm from "./TripForm"
import TripStatusSelect from "./components/TripStatusSelect"
import EncargadoField from "./components/EncargadoField"
import Desglose from '../reservations/Desglose'
import Contrato from './Contrato'
import PlanDeViaje from './PlanDeViaje'
import PropuestaModal from './PropuestaModal'
import DocDetallesModal from './DocDetallesModal'
import VouchersModal from './VouchersModal'
import TripTasks from '../tasks/TripTasks'
import PlanTriggerModal from '../trips/PlanTriggerModal'
import TripPayments from './TripPayments'
import TripTickets from './TripTickets'

import { calculateTripPrice } from '../../lib/TripTools'
import { getText, getLanguage, getTextWithTokens } from '../lib/text'
import LogViewer from '../logs/LogViewer'
import AppClient from './AppClient/AppClient'
import TripPeople from './TripPeople'

import {
  getReadyState,
  getTripForUrl,
  getBlocks,
  getCitiesIdList,
  getActivitiesList,
  getSortedExpenses,
  getBlocksList,
  getUsernames,
  getActiveUsernames,
  getFromQuery,
  getTripTags
} from '../selectors'

import { can } from '../components/IfAllowed'

import "./TripPage.less"

/**
 *
 */
function getQuery() {
  return browserHistory.getCurrentLocation().query
}

function goto(changes) {
  replaceQuery(browserHistory, { ...getQuery(), ...changes })
}

function setTab(tab) {
  goto({ tab })
}

const tabs = {
  1: "Datos",
  2: "Ruta",
  3: "Tareas y comentarios",
  4: "Comentarios",
  5: "Pagos",
  6: "Reservas",
  7: "Entradas",
  8: "Log",
  9: "App",
}

type Props = {
  ready: boolean,

  trip:           ?{[string]: Object}, // .isRequired, but actually cant mark it cos it aint there before fetching
  activities:     ?{[string]: Object}, // same
  routes:         ?{[string]: Object}, // same
  Cities:         ?{[string]: Object}, // same
  query:          Object,
  tags:           Object,
  blockTemplates: ?Object, // same
  dirty:          boolean,
  usernames:      [string],
  activeUserNames: [string],
  userPermissions: Object,

  loginData: Object,

  lastListPath:   ?string,
  onTripChange:   Function,
  routeParams:    {[string]: string}
}

class TripPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { modal: null, tab: 1 }

    this.bound_onPeopleChange = (
      changes => this.props.onTripChange2(this.props.trip._id, {
        people: { ...this.props.trip.people, ...changes }
      })
    )
  }

  props: Props

  updateTrip(k, v) {
    this.props.onTripChange(this.props.routeParams.id, k, v)
  }

  renderCustomizerHeader(trip, _route, tripPrice) {
    return (
      <div>
        {
          [
            [
              { modal: "propuesta",    glyph: "open-file", label: getText("Propuesta"), disabled: this.props.dirty },
              { modal: "pdf_settings", glyph: "cog",       label: "", disabled: this.props.dirty },
            ],
            [
              { modal: "doc2", glyph: "open-file", label: "Doc 2", disabled: this.props.dirty },
            ],
            [
              { modal: "contrato",    glyph: "usd",          label: getText("Contrato") },
              { modal: "plandeviaje", glyph: "th-list",      label: getText("Plan de viaje") },
              { modal: "vouchers",    glyph: "cloud-upload", label: getText("Vouchers"), disabled: this.props.dirty },
            ]
          ].map((buttonGroup, i) => (
            <ButtonGroup key={i} style={{ marginRight: 10 }}>
              {
                buttonGroup.map(({ modal, glyph, label, disabled }) => (
                  <Button
                    key={modal}
                    onClick={() => { this.setState({ modal }) }}
                    glyph={glyph}
                    disabled={disabled}
                  >
                    {label}
                  </Button>
                ))
              }
            </ButtonGroup>
          ))
        }

        <div style={{ float: "right", marginLeft: 30 }}>
          <PriceTag price={tripPrice} trip={trip} />
          <ButtonGroup style={{ marginRight: 15, marginLeft: 15 }}>
            <Button bsSize="xsmall" glyph="pencil" onClick={() => this.setState({ modal: "pricing" })}>
              {getText("Editar")}
            </Button>
          </ButtonGroup>
        </div>
        <div style={{ clear:"both" }} />
      </div>
    )
  }

  renderModal(trip, route, tripPrice) {
    const { activities, Cities } = this.props
    const hideModal = () => this.setState({ modal: null })

    if (this.state.modal === "pricing") {
      return (
        <PriceSettingsModal
          trip={trip}
          price={tripPrice}
          updateTrip={(k, v) => this.updateTrip(k, v)}
          close={hideModal}
        />
      )
    }
    else if (this.state.modal == "plandeviaje") {
      return (
        <PlanDeViaje
          trip={trip}
          route={route}
          onClose={hideModal}
        />
      )
    }
    else if (this.state.modal == "contrato") {
      return (
        <Contrato
          trip={trip}
          route={route}
          onClose={hideModal}
        />
      )
    }
    else if (this.state.modal === "pdf_settings") {
      return (
        <PdfSettingsModal
          id={trip._id}
          dirty={this.props.dirty}
          settings={trip.settings}
          update={v => this.props.onTripChange(trip._id, "settings", v)}
          close={hideModal}
        />
      )
    }
    else if (this.state.modal == "doc2") {
      return (
        <DocDetallesModal trip={trip} close={hideModal} />
      )
    }
    else if (this.state.modal === "propuesta") {
      return (
        <PropuestaModal
          trip={trip}
          route={route}
          Activities={activities}
          Cities={Cities}
          advanceStatus={() => this.props.onTripChange(trip._id, "status", 20)}
          cancel={hideModal}
        />
      )
    }
    else if (this.state.modal === "vouchers") {
      return (
        <VouchersModal
          trip={trip}
          route={route}
          activities={activities}
          close={hideModal}
          cancel={hideModal}
        />
      )
    }

    return null
  }

  render() {
    const { id } = this.props.routeParams
    const { activities, trip, routes } = this.props

    const mainRoute = trip && routes[trip.mainRoute]

    if (!this.props.ready) {
      return (<p>Loading...</p>)
    }

    const t = trip
    const tripPrice = calculateTripPrice(trip, mainRoute, this.props.activities, this.props.Cities)

    return (
      <div className="tripPage" style={{ padding: "15px", margin: "auto", maxWidth: 1400 }}>
        <DocumentTitle
          title={
            `${getText(tabs[this.props.query.tab])}: ${getLanguage() == "es" && trip.realName ? trip.realName : trip.name ? trip.name : trip.realName}`
          }
        />

        <Row className="tripPageRow">
          <Col md={5}>
            <Link
              style={{ fontWeight: "bold", fontSize: "15px" }}
              to={this.props.lastListPath}
            >
              <Glyphicon glyph="arrow-left" /> {getText("Lista de viajes")}
            </Link>
          </Col>
          <Col md={7}>
            <EncargadoField
              style={{ marginLeft: 30 }}
              onChange={evt => this.props.onTripChange(id, "encargado", evt.target.value)}
              onClick={() => this.props.onTripChange(id, "encargado", this.props.loginData.username)}
              value={trip.encargado || ""}
              usernames={Array.from(this.props.activeUserNames)}
            />
            <TripStatusSelect
              style={{ float: "right", marginRight: 40 }}
              status={t.status}
              onChange={v => this.props.onTripChange(id, "status", v)}
            />
          </Col>
        </Row>

        <Nav
          className="Tabs"
          bsStyle="tabs"
          activeKey={parseInt(this.props.query.tab)}
          onSelect={tab => { console.log(tab); setTab(tab) }}
        >
          <NavItem eventKey={1}>👤 {getText("Datos")}</NavItem>
          <NavItem eventKey={2}>🗺 {getText("Ruta")}</NavItem>
          {
            isMobile()
              ? ([
                <NavItem key="3" eventKey={3}>☑️ {getText("Tareas")}</NavItem>,
                <NavItem key="4" eventKey={4}>💬 {getText("Comentarios")}</NavItem>
              ])
              : (
                <NavItem eventKey={3}>💬 {getText("Tareas y comentarios")}</NavItem>
              )
          }
          <NavItem eventKey={5}>💵 {getText("Pagos")}</NavItem>
          {
            can(this.props.userPermissions, "read", "reservations") && (
              <NavItem eventKey={6}>🏨 {getText("Reservas")}</NavItem>
            )
          }
          <NavItem eventKey={7}>🎟 {getText("Entradas")}</NavItem>
          <NavItem eventKey={8}>📖 {getText("Log")}</NavItem>
          <NavItem eventKey={9}>📱 {getText("App")}</NavItem>
        </Nav>

        {
          this.props.query.tab == 1 && (
            <div>
              <Panel className="main">
                <Panel.Body>
                  <TripForm
                    cities={this.props.Cities}
                    trip={trip}
                    tags={this.props.tags}
                    username={this.props.loginData.username}
                    onTripChange={(k, v) => this.props.onTripChange(id, k, v)}
                    onUnset={(k) => this.props.onUnset(id, k)}
                  />
                  <div className="deleteButtonWrapper">
                    <Button
                      glyph="remove"
                      bsStyle="link"
                      onClick={() => {
                        // #TODO don't use confirm
                        /* eslint-disable-next-line no-alert no-restricted-globals */
                        if (confirm(getTextWithTokens(`delete_trip`, [trip.name || "[Sin nombre]"]))) {
                          browserHistory.push(this.props.lastListPath)
                          this.props.removeTrip(id)
                        }
                      }}
                    >
                      Eliminar viaje
                    </Button>
                  </div>
                </Panel.Body>
              </Panel>

              {/* this brings its own panel */}
              <TripPeople
                name={trip.officialName || trip.realName || trip.name}
                people={trip.people}
                onChange={this.bound_onPeopleChange}
              />
            </div>
          )
        }

        {
          this.props.query.tab == 2 && (
            <Panel className="main">
              <Panel.Body>
                {
                  this.renderCustomizerHeader(trip, mainRoute, tripPrice)
                }

                <RouteTabber
                  Activities={activities}
                  addBlock={(id, route, itarget) => this.props.addBlock(id, route, itarget)}
                  blockTemplates={this.props.blockTemplates}
                  replaceWithBlock={(rid, block) => this.props.replaceWithBlock(rid, block, routes[block.route])}
                  routes={routes}
                  Routes={this.props.routes}
                  startDate={trip.startDate}
                  trip={trip}
                  tripPrice={tripPrice}
                  {...pick(this.props, [
                    "move",
                    "addActivity",
                    "addCity",
                    "addDay",
                    "addExpense",
                    "addNote",
                    "editItem",
                    "updateExpenses",
                    "remove",
                    "multiMove",
                    "CitiesList",
                    "AliveActivitiesList",
                    "blockTemplatesList",
                    "createBlock",
                    "repeatExpense",
                    "moveItem",
                    "ExpensesList",
                  ])}
                />
              </Panel.Body>
            </Panel>
          )
        }

        {
          !isMobile() && (this.props.query.tab == 3 || this.props.query.tab == 4) && (
            <Panel className="main">
              <Panel.Body>
                <Row>
                  <Col md={6}>
                    <TripNotesEditor
                      panel
                      trip={trip}
                      onTripChange={(k, v) => this.props.onTripChange(id, k, v)}
                    />
                  </Col>
                  <Col md={6}>
                    <TripTasks panel trip={trip} />
                  </Col>
                </Row>
              </Panel.Body>
            </Panel>
          )
        }

        {
          isMobile() && this.props.query.tab == 3 && (<TripTasks panel trip={trip} />)
        }

        {
          isMobile() && this.props.query.tab == 4 && (
            <TripNotes
              panel
              trip={trip}
              onTripChange={(k, v) => this.props.onTripChange(id, k, v)}
            />
          )
        }

        {
          this.props.query.tab == 5 && (
            <TripPayments
              trip={trip}
              onChange={payments => this.props.onTripChange(id, "payments", payments)}
              tripPrice={tripPrice}
            />
          )
        }

        {
          this.props.query.tab == 6 && (
            <Desglose
              trip={trip}
              editTrip={changes => this.props.onTripChange2(id, changes)}
              route={mainRoute}
              Activities={this.props.activities}
              Cities={this.props.Cities}
            />
          )
        }

        {
          this.props.query.tab == 7 && (
            <TripTickets
              trip={trip}
              onChange={tickets => this.props.onTripChange2(id, { tickets })}
              route={mainRoute}
              Cities={this.props.Cities}
              Activities={this.props.activities}
            />
          )
        }

        {
          this.props.query.tab == 8 && (
            <Panel className="main">
              <Panel.Body>
                <LogViewer col="trips" id={trip._id} />
              </Panel.Body>
            </Panel>
          )
        }

        {
          this.props.query.tab == 9 && (
            <AppClient
              trip={trip}
              onChange={changes => this.props.onTripChange2(trip._id, changes)}
            />
          )
        }

        { this.renderModal(trip, mainRoute, tripPrice) }

        <PlanTriggerModal />

      </div>
    )
  }
}

TripPage.defaultProps = {
  lastListPath: "/private/oper"
}

function mapStateToProps(state, props) {
  const trip = getTripForUrl(state, props)
  const { routes, activities } = state
  const Cities = state.cities

  const mainRoute = trip ? state.routes[trip.mainRoute] : null
  
  return {
    tasks: state.tasks, // to force it to upate when tasks change
    ready: getReadyState(state, props),

    blockTemplates: getBlocks(state, props),
    usernames:      getUsernames(state, props),
    activeUserNames: getActiveUsernames(state, props),
    trip,
    routes,
    mainRoute,
    activities,
    Cities,
    userPermissions: state.permissions.userPermissions,

    tags: getTripTags(state, props),

    loginData:      state.loginData,
    dirty:          state.persistence.dirty,
    lastListPath:   state.historyCache.oper,

    CitiesList: getCitiesIdList(state, props),
    AliveActivitiesList: getActivitiesList(state, props),
    ExpensesList: getSortedExpenses(state, props),
    blockTemplatesList: getBlocksList(state, props),

    query: {
      tab: getFromQuery(state, props)("tab") || 1,
    },
  }
}

const mapDispatchToProps = (dispatch) => ({
  // #TODO only use new onTripChange
  onTripChange: (id, k, v) => dispatch(Actions.updateTrip(id, { [k]: v })),
  onTripChange2: (id, changes) => dispatch(Actions.updateTrip(id, changes)),

  onUnset: (id, k, _v) => dispatch(Actions.unsetTripProp(id, k)),

  addActivity:     (id, a, itarget)     => dispatch(RouteActions.addActivity(id, a, itarget || null)),
  addBlock:        (id, route, itarget) => dispatch(RouteActions.addBlock(id, route, itarget || null)),
  addCity:         (id, city, itarget)  => dispatch(RouteActions.addCity(id, city, itarget || null)),
  addDay:          (id, itarget)        => dispatch(RouteActions.addDay(id, itarget || null)),
  addExpense:      (id, x, itarget)     => dispatch(RouteActions.addExpense(id, x, itarget || null)),
  addNote:         (id, itarget)        => dispatch(RouteActions.addNote(id, itarget || null)),

  editItem:        (id, itarget, k, v)  => dispatch(RouteActions.editItem(id, itarget, { [k]: v })),
  removeTrip:      (id) => dispatch(Actions.removeTrip(id)),

  move:            (id, itarget, dir)   => dispatch(RouteActions.updateContent(id, dir, itarget)),
  moveItem:        (id, i, newPos)      => dispatch(RouteActions.moveItem(id, i, newPos)),
  multiMove:       (id, ii, dir)        => dispatch(RouteActions.multiMove(id, dir, ii)),
  remove:          (id, itarget, flag)  => dispatch(RouteActions.remove(id, itarget, flag)),
  repeatExpense:   (id, isrc, idst)     => dispatch(RouteActions.repeatExpense(id, isrc, idst)),
  updateExpenses:  (id, expenses)       => dispatch(RouteActions.updateExpenses(id, expenses)),

  replaceWithBlock: (rid, block, blockRoute) => dispatch(RouteActions.replaceWithBlock(rid, block, blockRoute)),

  createBlock: (name, route, clientName) => dispatch(createBlock(
    { name, route, note: `加载客户线路 / Ruta importada ${(clientName ? ` de ${clientName}` : "")}` },
    id => l(`block w/ id ${id}`)
  )),
})

export default connect(mapStateToProps, mapDispatchToProps)(TripPage)
